import { render } from "./DownloadData.vue?vue&type=template&id=1fe844b4&scoped=true"
import script from "./DownloadData.vue?vue&type=script&lang=js"
export * from "./DownloadData.vue?vue&type=script&lang=js"

import "./DownloadData.vue?vue&type=style&index=0&id=1fe844b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe844b4"]])

export default __exports__